/** @type {Record<string, Record<string, string>>} */
export const profileUi = {
  title: {
    en: 'Profile settings',
    ru: 'Настройки профиля',
    es: 'Configuración del perfil',
    fr: 'Paramètres du profil',
    zh: '个人资料设置',
    hi: 'प्रोफ़ाइल सेटिंग्स',
  },
  back: {
    en: '← Back',
    ru: '← Назад',
    es: '← Volver',
    fr: '← Retour',
    zh: '← 返回',
    hi: '← वापस',
  },
  role: {
    en: 'Role',
    ru: 'Роль',
    es: 'Rol',
    fr: 'Rôle',
    zh: '角色',
    hi: 'भूमिका',
  },
  organization: {
    en: 'Organization',
    ru: 'Организация',
    es: 'Organización',
    fr: 'Organisation',
    zh: '组织',
    hi: 'संगठन',
  },
  client: {
    en: 'Client',
    ru: 'Клиент',
    es: 'Cliente',
    fr: 'Client',
    zh: '客户',
    hi: 'ग्राहक',
  },
  emailVerified: {
    en: 'Email verified',
    ru: 'Email подтверждён',
    es: 'Correo verificado',
    fr: 'E-mail vérifié',
    zh: '邮箱已验证',
    hi: 'ईमेल सत्यापित',
  },
  markVerified: {
    en: 'Mark email verified',
    ru: 'Отметить email подтверждённым',
    es: 'Marcar correo como verificado',
    fr: 'Marquer l’e-mail comme vérifié',
    zh: '标记邮箱已验证',
    hi: 'ईमेल सत्यापित चिह्नित करें',
  },
  details: {
    en: 'Details',
    ru: 'Данные',
    es: 'Datos',
    fr: 'Coordonnées',
    zh: '基本信息',
    hi: 'विवरण',
  },
  name: {
    en: 'Name',
    ru: 'Имя',
    es: 'Nombre',
    fr: 'Nom',
    zh: '姓名',
    hi: 'नाम',
  },
  email: {
    en: 'Email',
    ru: 'Email',
    es: 'Correo',
    fr: 'E-mail',
    zh: '邮箱',
    hi: 'ईमेल',
  },
  language: {
    en: 'Interface language',
    ru: 'Язык интерфейса',
    es: 'Idioma de la interfaz',
    fr: 'Langue de l’interface',
    zh: '界面语言',
    hi: 'इंटरफ़ेस भाषा',
  },
  languageHint: {
    en: 'Used for guided tours and localized messages. Default is English.',
    ru: 'Для обучения и локализованных сообщений. По умолчанию — английский.',
    es: 'Para tours guiados y mensajes localizados. El predeterminado es inglés.',
    fr: 'Pour les visites guidées et les messages localisés. L’anglais par défaut.',
    zh: '用于引导教程和本地化消息。默认为英语。',
    hi: 'गाइडेड टूर और स्थानीय संदेशों के लिए। डिफ़ॉल्ट अंग्रेज़ी।',
  },
  onboardingEnabled: {
    en: 'Interactive tour prompts',
    ru: 'Подсказки обучения',
    es: 'Avisos del tour interactivo',
    fr: 'Invitations à la visite guidée',
    zh: '互动导览提示',
    hi: 'इंटरैक्टिव टूर संकेत',
  },
  onboardingEnabledHint: {
    en: 'Show welcome tour offers when you open new pages. You can always start a tour with the ? Tour button.',
    ru: 'Показывать предложения обучения на новых страницах. Запустить вручную можно кнопкой «? Обучение».',
    es: 'Mostrar invitaciones al tour en páginas nuevas. Siempre puede iniciarlo con el botón ? Tour.',
    fr: 'Afficher les invitations au tour sur les nouvelles pages. Lancez-le avec le bouton ? Tour.',
    zh: '打开新页面时显示导览邀请。可随时用 ? 导览 按钮手动开始。',
    hi: 'नए पेज पर टूर के सुझाव दिखाएँ। ? टूर बटन से कभी भी शुरू करें।',
  },
  saveProfile: {
    en: 'Save profile',
    ru: 'Сохранить профиль',
    es: 'Guardar perfil',
    fr: 'Enregistrer le profil',
    zh: '保存资料',
    hi: 'प्रोफ़ाइल सहेजें',
  },
  changePassword: {
    en: 'Change password',
    ru: 'Сменить пароль',
    es: 'Cambiar contraseña',
    fr: 'Changer le mot de passe',
    zh: '更改密码',
    hi: 'पासवर्ड बदलें',
  },
  currentPassword: {
    en: 'Current password',
    ru: 'Текущий пароль',
    es: 'Contraseña actual',
    fr: 'Mot de passe actuel',
    zh: '当前密码',
    hi: 'वर्तमान पासवर्ड',
  },
  newPassword: {
    en: 'New password',
    ru: 'Новый пароль',
    es: 'Nueva contraseña',
    fr: 'Nouveau mot de passe',
    zh: '新密码',
    hi: 'नया पासवर्ड',
  },
  confirmPassword: {
    en: 'Confirm',
    ru: 'Подтверждение',
    es: 'Confirmar',
    fr: 'Confirmer',
    zh: '确认',
    hi: 'पुष्टि',
  },
  updatePassword: {
    en: 'Update password',
    ru: 'Обновить пароль',
    es: 'Actualizar contraseña',
    fr: 'Mettre à jour le mot de passe',
    zh: '更新密码',
    hi: 'पासवर्ड अपडेट करें',
  },
  profileUpdated: {
    en: 'Profile updated.',
    ru: 'Профиль обновлён.',
    es: 'Perfil actualizado.',
    fr: 'Profil mis à jour.',
    zh: '资料已更新。',
    hi: 'प्रोफ़ाइल अपडेट हो गई।',
  },
  passwordChanged: {
    en: 'Password changed.',
    ru: 'Пароль изменён.',
    es: 'Contraseña cambiada.',
    fr: 'Mot de passe modifié.',
    zh: '密码已更改。',
    hi: 'पासवर्ड बदल गया।',
  },
  emailSignature: {
    en: 'Email signature',
    ru: 'Подпись письма',
    es: 'Firma de correo',
    fr: 'Signature d’e-mail',
    zh: '邮件签名',
    hi: 'ईमेल हस्ताक्षर',
  },
  emailSignatureHint: {
    en: 'Added to new messages and replies from your Outlook mailbox.',
    ru: 'Добавляется к новым письмам и ответам из вашего ящика Outlook.',
    es: 'Se añade a los mensajes nuevos y a las respuestas de su buzón de Outlook.',
    fr: 'Ajoutée aux nouveaux messages et aux réponses de votre boîte Outlook.',
    zh: '会加到您 Outlook 邮箱发出的新邮件和回复中。',
    hi: 'आपके Outlook मेलबॉक्स से नए संदेशों और जवाबों में जुड़ता है।',
  },
  emailMarkedVerified: {
    en: 'Email marked verified.',
    ru: 'Email отмечен как подтверждённый.',
    es: 'Correo marcado como verificado.',
    fr: 'E-mail marqué comme vérifié.',
    zh: '邮箱已标记为已验证。',
    hi: 'ईमेल सत्यापित चिह्नित किया गया।',
  },
  twoFactorTitle: {
    en: 'Two-factor authentication',
    ru: 'Двухфакторная аутентификация',
    es: 'Autenticación en dos pasos',
    fr: 'Authentification à deux facteurs',
    zh: '双重验证',
    hi: 'दो-कारक प्रमाणीकरण',
  },
  twoFactorHint: {
    en: 'Add a 6-digit code from an authenticator app when you sign in.',
    ru: 'При входе запрашивать 6-значный код из приложения-аутентификатора.',
    es: 'Pida un código de 6 dígitos de una aplicación de autenticación al iniciar sesión.',
    fr: 'Demandez un code à 6 chiffres d’une application d’authentification à la connexion.',
    zh: '登录时使用身份验证器应用中的 6 位验证码。',
    hi: 'साइन इन करते समय ऑथेंटिकेटर ऐप का 6 अंकों का कोड माँगें।',
  },
  twoFactorOn: {
    en: 'Two-factor authentication is on.',
    ru: 'Двухфакторная защита включена.',
    es: 'La autenticación en dos pasos está activada.',
    fr: 'L’authentification à deux facteurs est activée.',
    zh: '双重验证已开启。',
    hi: 'दो-कारक प्रमाणीकरण चालू है।',
  },
  twoFactorOff: {
    en: 'Two-factor authentication is off.',
    ru: 'Двухфакторная защита выключена.',
    es: 'La autenticación en dos pasos está desactivada.',
    fr: 'L’authentification à deux facteurs est désactivée.',
    zh: '双重验证已关闭。',
    hi: 'दो-कारक प्रमाणीकरण बंद है।',
  },
  twoFactorRequiredNote: {
    en: 'Your administrator requires it, so you cannot turn it off.',
    ru: 'Администратор требует её, поэтому отключить её нельзя.',
    es: 'Su administrador la exige, así que no puede desactivarla.',
    fr: 'Votre administrateur l’exige, vous ne pouvez pas la désactiver.',
    zh: '管理员要求开启，因此无法关闭。',
    hi: 'आपका एडमिन इसे अनिवार्य करता है, इसलिए आप इसे बंद नहीं कर सकते।',
  },
  twoFactorEnable: {
    en: 'Set up authenticator app',
    ru: 'Подключить приложение',
    es: 'Configurar la aplicación',
    fr: 'Configurer l’application',
    zh: '设置身份验证器',
    hi: 'ऑथेंटिकेटर सेट करें',
  },
  twoFactorQr: {
    en: 'QR code for authenticator app',
    ru: 'QR-код для приложения-аутентификатора',
    es: 'Código QR para la aplicación de autenticación',
    fr: 'QR code pour l’application d’authentification',
    zh: '身份验证器二维码',
    hi: 'ऑथेंटिकेटर ऐप का QR कोड',
  },
  twoFactorManual: {
    en: 'Scan the QR code, or enter this key in the app.',
    ru: 'Отсканируйте QR-код или введите этот ключ в приложении.',
    es: 'Escanee el código QR o introduzca esta clave en la aplicación.',
    fr: 'Scannez le QR code ou saisissez cette clé dans l’application.',
    zh: '扫描二维码，或在应用中输入此密钥。',
    hi: 'QR कोड स्कैन करें, या ऐप में यह कुंजी दर्ज करें।',
  },
  twoFactorCode: {
    en: '6-digit code',
    ru: '6-значный код',
    es: 'Código de 6 dígitos',
    fr: 'Code à 6 chiffres',
    zh: '6 位验证码',
    hi: '6 अंकों का कोड',
  },
  twoFactorConfirm: {
    en: 'Confirm and turn on',
    ru: 'Подтвердить и включить',
    es: 'Confirmar y activar',
    fr: 'Confirmer et activer',
    zh: '确认并开启',
    hi: 'पुष्टि करें और चालू करें',
  },
  twoFactorCancel: {
    en: 'Cancel',
    ru: 'Отмена',
    es: 'Cancelar',
    fr: 'Annuler',
    zh: '取消',
    hi: 'रद्द करें',
  },
  twoFactorDisable: {
    en: 'Turn off authenticator',
    ru: 'Отключить приложение',
    es: 'Desactivar la aplicación',
    fr: 'Désactiver l’application',
    zh: '关闭身份验证器',
    hi: 'ऑथेंटिकेटर बंद करें',
  },
  twoFactorRegenerate: {
    en: 'Generate new recovery codes',
    ru: 'Новые резервные коды',
    es: 'Generar códigos de recuperación nuevos',
    fr: 'Générer de nouveaux codes de secours',
    zh: '生成新的恢复码',
    hi: 'नए रिकवरी कोड बनाएँ',
  },
  twoFactorRecoveryHint: {
    en: 'Save these recovery codes. Each code works once if you lose the app.',
    ru: 'Сохраните резервные коды. Каждый код срабатывает один раз, если нет доступа к приложению.',
    es: 'Guarde estos códigos. Cada uno funciona una vez si pierde la aplicación.',
    fr: 'Conservez ces codes. Chacun fonctionne une fois si vous perdez l’application.',
    zh: '请保存这些恢复码。丢失应用后，每个恢复码只能使用一次。',
    hi: 'ये रिकवरी कोड सहेजें। ऐप खोने पर हर कोड एक बार काम करता है।',
  },
  twoFactorEnabledMsg: {
    en: 'Authenticator app is on.',
    ru: 'Приложение-аутентификатор включено.',
    es: 'La aplicación de autenticación está activada.',
    fr: 'L’application d’authentification est activée.',
    zh: '身份验证器已开启。',
    hi: 'ऑथेंटिकेटर ऐप चालू हो गया।',
  },
  twoFactorDisabledMsg: {
    en: 'Authenticator app is off.',
    ru: 'Приложение-аутентификатор выключено.',
    es: 'La aplicación de autenticación está desactivada.',
    fr: 'L’application d’authentification est désactivée.',
    zh: '身份验证器已关闭。',
    hi: 'ऑथेंटिकेटर ऐप बंद हो गया।',
  },
  twoFactorRecoveryReady: {
    en: 'New recovery codes are ready. The previous codes no longer work.',
    ru: 'Новые резервные коды готовы. Прежние больше не работают.',
    es: 'Los códigos nuevos están listos. Los anteriores ya no funcionan.',
    fr: 'Les nouveaux codes sont prêts. Les anciens ne fonctionnent plus.',
    zh: '新的恢复码已生成。之前的恢复码已失效。',
    hi: 'नए रिकवरी कोड तैयार हैं। पुराने कोड अब काम नहीं करेंगे।',
  },
};
